import { render, staticRenderFns } from "./Promotion_percent.vue?vue&type=template&id=42d3b8a8&scoped=true&"
import script from "./Promotion_percent.vue?vue&type=script&lang=js&"
export * from "./Promotion_percent.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_percent.vue?vue&type=style&index=0&id=42d3b8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d3b8a8",
  null
  
)

export default component.exports